import { ActivatedRouteSnapshot } from "@angular/router";

export function parseRouteParamNumber(route: ActivatedRouteSnapshot, paramName: string): number | null {
  const paramValue: string | null = route.paramMap.get(paramName);
  if (!paramValue) return null;

  const id: number = Number(paramValue);
  return Number.isFinite(id) ? id : null;
}
